import { render, staticRenderFns } from "./DxWorkOrderEdit.vue?vue&type=template&id=51d140aa&"
import script from "./DxWorkOrderEdit.vue?vue&type=script&lang=js&"
export * from "./DxWorkOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports